import React from "react";
import formatMetric from "../util/formatMetric";
const CounterRate = ({ metric = null, prefix = "", suffix = "" }) => {
  if (!metric) {
    return null;
  }
  const {
    rate: { one_minute: oneMinute }
  } = metric;
  return /* @__PURE__ */ React.createElement("span", null, prefix ? `${prefix} ` : null, formatMetric(oneMinute), suffix ? ` ${suffix}` : null);
};
export default CounterRate;
